import { SET_USER_OLD_FORM, SET_RESUME_UPLOAD } from "../action/setOldForm";

const initialState = { resumeUpload: false }; // Use an object instead of an empty string

export default function OldFormReducer(state = initialState, action) {
  switch (action.type) {
    case SET_USER_OLD_FORM: {
      const data = action.payload;
      state = data;
      return { ...state };
    }

    case SET_RESUME_UPLOAD: {
      const resume = action.payload;
      state.resumeUpload = resume;
      return { ...state };
    }

    default:
      return state;
  }
}
